import { useState } from 'react';

const navLinks = [
  { label: '首页', href: '#home' },
  { label: '平台介绍', href: '#platform' },
  { label: '核心功能', href: '#features' },
  { label: '热门内容', href: '#content' },
  { label: '使用指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
  { label: '关于我们', href: '#about' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 transition-all duration-300 bg-background-50/90 backdrop-blur-md border-b border-background-200"
    >
      <nav className="w-full max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap" aria-label="歪歪官方网站首页">
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-live-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-lg md:text-xl text-foreground-950">
            歪歪官方网站
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1 lg:gap-2">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 whitespace-nowrap transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="https://www.yy.com"
            target="_blank"
            rel="nofollow noopener"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            <i className="ri-external-link-line text-sm" aria-hidden="true"></i>
            进入官方首页
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 rounded-md bg-background-100 text-foreground-900 flex items-center justify-center"
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-800 hover:text-primary-600 rounded-md hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://www.yy.com"
              target="_blank"
              rel="nofollow noopener"
              className="mt-2 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600"
            >
              <i className="ri-external-link-line text-sm" aria-hidden="true"></i>
              进入官方首页
            </a>
          </div>
        </div>
      )}
    </header>
  );
}